import { CountryShortDto, TNsiState } from './types';

export function getNsiCountryListWithData(state: TNsiState): (CountryShortDto & { value: number; label: string })[] {
  return state.nsiCountryListWithData.map((item) => ({ ...item, value: item.id, label: item.nameFull || item.name }));
}

export function getNsiBusinessTipsStatusList(state: TNsiState) {
  return state.nsiBusinessTipsStatusList.map((item) => ({ ...item, value: item.id, label: item.name }));
}
